//存储已签字数据
const state = {
    SelectSignature:{},
    CustomSignatureId:''
  };
  const getters = {
    SelectSignature: state => {
      return state.SelectSignature;
    }
  };
  const mutations = {
    SelectSignature(state, value) {
       state.SelectSignature = value;
    },
    CustomSignature(state,value){
       state.CustomSignatureId = value;
    }
  };
  export default {
    state,
    getters,
    mutations
  };
  


// WEBPACK FOOTER //
// ./src/store/modules/SelectSignature.js